import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Auth/Login';
import ForgotPassword from './pages/Auth/ForgotPassword';
import ResetPassword from './pages/Auth/ResetPassword';
import Home from './pages/Home/Home';
import About from './pages/About/About';
import Plan from './pages/Plan/Plan';
import Blog from './pages/Blog/Blog';
import BlogDetail from './pages/Blog/BlogDetail';
import UserList from './pages/Home/UserList';
import UserDetails from './pages/Home/UserDetails';
import Video from './pages/Video/Video';
import Career from './pages/Career/Career';
import Contact from './pages/Contact/Contact';
import Faq from './pages/Faq/Faq';
import PayNow from './pages/PrivacyPolicy/PayNow';
import CheckStatus from './components/CheckStatus';


import Newsletter from './pages/PrivacyPolicy/Newsletter';
import Privacypolicy from './pages/PrivacyPolicy/Privacypolicy';
import TeamMember from './pages/PrivacyPolicy/TeamMember';
import Termscondition from './pages/PrivacyPolicy/Termscondition';
import RefundPolicy from './pages/PrivacyPolicy/RefundPolicy';
import Register from './pages/Auth/Register';
import AdminLayout from './components/layouts/AdminLayout';
import AdminDashboard from './pages/Admin/Dashboard';
import UserManagement from './pages/Admin/UserManagement';
import UserSuspending from './pages/Admin/UserSuspending';
import UserPendingManagement from './pages/Admin/UserPendingManagement';
import PlanManagement from './pages/Admin/PlanManagement';
import ContentManagement from './pages/Admin/ContentManagement';
import CategoryManagement from './pages/Admin/CategoryManagement';
import HomeManagement from './pages/Admin/HomeManagement';
import AboutManagement from './pages/Admin/AboutManagement';
import SubscriberManagement from './pages/Admin/SubscriberManagement';
import CareerManagement from './pages/Admin/CareerManagement';
import SubscribedUserManagement from './pages/Admin/SubscribedUserManagement';


import PartnersEnquiries from './pages/Admin/EnquiryTypes/PartnersEnquiries';
import ServicesEnquiries from './pages/Admin/EnquiryTypes/ServicesEnquiries';
import SkilledEnquiries from './pages/Admin/EnquiryTypes/SkilledEnquiries';
import FranchiseeEnquiries from './pages/Admin/EnquiryTypes/FranchiseeEnquiries';
import BusinessEnquiries from './pages/Admin/EnquiryTypes/BusinessEnquiries';
import ThirdPartyEnquiries from './pages/Admin/EnquiryTypes/ThirdPartyEnquiries';
import UserDashboard from './pages/User/Dashboard'; // Add this import
import ProtectedRoute from './components/ProtectedRoute';
import './styles.css';

const App = () => {
  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/plan" element={<Plan />} />
        <Route path="/faqs" element={<Faq />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogDetail />} />
        <Route path="/users" element={<UserList />} />
        <Route path="/user-details/:userId" element={<UserDetails />} />
        <Route path="/video" element={<Video />} />
        {/* <Route path="/career" element={<Career />} /> */}
        <Route path="/faq" element={<Faq />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/newsletter" element={<Newsletter />} />
        <Route path="/privacypolicy" element={<Privacypolicy />} />
        <Route path="/termscondition" element={<Termscondition />} />
        <Route path="/refundpolicy" element={<RefundPolicy />} />
        <Route path="/teammember" element={<TeamMember />} />
          <Route path="/check-status" element={<CheckStatus />} />
         
        <Route path="/forgot-password" element={<ForgotPassword />} />
<Route path="/reset-password" element={<ResetPassword />} />
    <Route path="/pay-now" element={<PayNow />} />
        {/* Unified User Dashboard Route */}
        <Route path="/dashboard" element={
          <ProtectedRoute allowedRoles={['Partner', 'Business', '3rd Party Services', 'Employee']}>
            <UserDashboard />
          </ProtectedRoute>
        } />

        {/* Admin Routes */}
        <Route path="/admin" element={
          <ProtectedRoute allowedRoles={['admin']}>
            <AdminLayout />
          </ProtectedRoute>
        }>
          <Route index element={<AdminDashboard />} />
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="users" element={<UserManagement />} />
          <Route path="categories" element={<CategoryManagement />} />
          <Route path="users/pending" element={<UserPendingManagement />} />
          <Route path="users/suspending" element={<UserSuspending />} />
          <Route path="content" element={<ContentManagement />} />
          <Route path="plans" element={<PlanManagement />} />
          <Route path="home" element={<HomeManagement />} />
          <Route path="about" element={<AboutManagement />} />
          <Route path="subscribed-users" element={<SubscribedUserManagement />} />
          <Route path="business/partners" element={<PartnersEnquiries />} />
          <Route path="business/services" element={<ServicesEnquiries />} />
          <Route path="business/skilled" element={<SkilledEnquiries />} />
          <Route path="business/franchisee" element={<FranchiseeEnquiries />} />
          <Route path="business" element={<BusinessEnquiries />} />
          <Route path="business/third-party" element={<ThirdPartyEnquiries />} />
          <Route path="subscribers" element={<SubscriberManagement />} />
          <Route path="career" element={<CareerManagement />} />
        </Route>

        {/* Remove individual role-based dashboard routes */}
        {/* <Route path="/partner/dashboard" element={...} /> */}
        {/* <Route path="/business/dashboard" element={...} /> */}
        {/* <Route path="/service-provider/dashboard" element={...} /> */}
        {/* <Route path="/professional/dashboard" element={...} /> */}
      </Routes>
    </Router>
  );
};

export default App;